/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import { noopDetector } from '../../NoopDetector';

export const processDetector = noopDetector;



// WEBPACK FOOTER //
// ../../../../../src/detectors/platform/browser/ProcessDetector.ts